import type { FunctionComponent } from 'react';
import { useState } from 'react';

import type { BlocklistMatch } from '@ballerine/business-analysis-schemas';

import { BlocklistTable } from './BlocklistTable';

const ROW_CAP = 10;

type BlocklistWidgetProps = {
  matches: BlocklistMatch[];
};

export const BlocklistWidget: FunctionComponent<BlocklistWidgetProps> = ({ matches }) => {
  const [showAll, setShowAll] = useState(false);

  if (matches.length === 0) {
    return null;
  }

  const hasOverflow = matches.length > ROW_CAP;
  const visibleMatches = showAll ? matches : matches.slice(0, ROW_CAP);
  const hiddenCount = matches.length - ROW_CAP;

  return (
    <div className="flex flex-col gap-2">
      <div className="max-h-[360px] overflow-auto rounded-md border border-zinc-200">
        <BlocklistTable matches={visibleMatches} />
      </div>

      {hasOverflow && (
        <button
          type="button"
          onClick={() => setShowAll(previous => !previous)}
          className="self-start text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          {showAll ? 'View less' : `+${hiddenCount} more`}
        </button>
      )}
    </div>
  );
};
